<template>
  <div class="top-wrap">
    <div class="top-line">
      <div class="line-label">机构</div>
      <div class="line-content">
        <div class="company-box">
          <div class="flex hot-company-list">
            <nuxt-link
              :to="GLOBAL_CONFIG.envConfig.origin + '/cert/l.html' + companyParams"
              :class="{
                'hot-company-item': true,
                'company-item-active': listStore.searchData.jointId === '',
              }"
            >
              <img src="@/src/assets/imgs/list/company-all-icon.png" alt="company-logo" />
              全部
            </nuxt-link>
            <nuxt-link
              v-for="item in listStore.optionList.company.hotCompanyList"
              :key="'company' + item.id"
              :to="item.url + companyParams"
              :class="{
                'hot-company-item': true,
                'company-item-active': item.id === listStore.searchData.jointId,
              }"
            >
              <img :src="item.logo" alt="company-logo" />
              {{ item.name }}
            </nuxt-link>
          </div>
          <div v-show="showOtherCompany" class="flex other-company-list">
            <nuxt-link
              v-for="item in listStore.optionList.company.otherCompanyList"
              :key="'company' + item.id"
              :to="item.url + companyParams"
              :class="{
                'company-item': true,
                'company-item-active': item.id === listStore.searchData.jointId,
              }"
            >
              {{ item.name }}
            </nuxt-link>
          </div>
          <img
            src="@/src/assets/imgs/list/more-icon.png"
            alt="more-icon"
            :class="{ 'more-icon': true, 'more-icon-rote': showOtherCompany }"
            @click="showOtherCompany = !showOtherCompany"
          />
        </div>
      </div>
    </div>
    <div class="top-line">
      <div class="line-label">方向</div>
      <div class="line-content flex">
        <div
          v-for="item in listStore.optionList.cateList"
          :key="item.cateId"
          :class="{
            'select-item': true,
            'select-item-active': item.cateId === listStore.searchData.pid,
          }"
          @click="selectFilter('pid', item.cateId)"
        >
          {{ item.cateName }}
        </div>
      </div>
    </div>
    <div v-show="secondCateList.length > 0" class="top-line">
      <div class="line-label">分类</div>
      <div class="line-content flex">
        <div
          v-for="(item, index) in secondCateList"
          :key="item.cateId"
          :class="{
            'select-item': true,
            'select-item-active': item.cateId === listStore.searchData.cid,
          }"
          @click="selectFilter('cid', item.cateId)"
        >
          {{ item.cateName }}
        </div>
      </div>
    </div>
    <div class="top-line mb-0">
      <div class="line-label">等级</div>
      <div class="line-content flex">
        <div
          v-for="(item, index) in listStore.optionList.levelList"
          :key="'level' + index"
          :class="{
            'select-item': true,
            'select-item-active': index === listStore.searchData.tag,
          }"
          @click="selectFilter('tag', index)"
        >
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useListStore } from '~/src/store/modules/certList';
import { GLOBAL_CONFIG } from '@/configs/environment/environment';
const listStore = useListStore();
const route = useRoute();
const secondCateList = computed(() => {
  return (
    listStore.optionList.cateList.find(item => item.cateId === listStore.searchData.pid)?.child ||
    []
  );
});
const showOtherCompany = ref(
  listStore.optionList.company.otherCompanyList.some(
    item => item.id === listStore.searchData.jointId
  )
);

const selectFilter = (type: string, id: string | number) => {
  if (type === 'pid') {
    listStore.searchData.cid = '0';
  }

  listStore.searchData[type] = id;
  listStore.searchData.page = 1;
  listStore.getListInfo();
  // listStore.getOtherData();
  listStore.addQueryParam(type, id);
};

const companyParams = ref('');
watch(
  () => route,
  newVal => {
    const currentUrl = new URL(window.location.href);
    const params = new URLSearchParams(currentUrl.search);
    companyParams.value = '?' + params.toString();
  },
  {
    deep: true,
  }
);
</script>

<style lang="scss">
.cert-list-page {
  .top-wrap {
    padding: 20px;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(44, 70, 137, 0.06);
  }

  .top-line {
    display: flex;
    margin-bottom: 20px;

    .line-label {
      width: 44px;
      flex-shrink: 0;
      color: #9399a5;
      font-size: 14px;
    }

    .line-content {
      flex: 1;
    }

    .company-type {
      display: flex;
      margin-bottom: 15px;
    }

    .company-box {
      position: relative;
      width: 100%;
      padding: 15px 20px 7px;
      background: #f5f9ff;

      .hot-company-list {
        padding-bottom: 15px;
        color: #333333;
        font-size: 14px;
        line-height: 1;

        .hot-company-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-right: 32px;
          cursor: pointer;

          &:hover {
            color: #3d64f3;
          }

          img {
            width: 22px;
            height: 22px;
            border-radius: 4px;
            margin-bottom: 7px;
          }
        }
      }

      .other-company-list {
        flex-wrap: wrap;
        padding: 7px 0;
        border-top: solid 1px #dee5f0;
        color: #333333;
        font-size: 14px;
        line-height: 28px;

        .company-item {
          margin-right: 32px;
          cursor: pointer;

          &:hover {
            color: #3d64f3;
          }
        }
      }

      .more-icon {
        position: absolute;
        top: 26px;
        right: 20px;
        width: 28px;
        height: 28px;
        cursor: pointer;
      }

      .more-icon-rote {
        transform: rotate(180deg);
      }

      .company-item-active {
        color: #3d64f3;
      }
    }

    .select-item {
      padding: 5px 16px;
      color: #333;
      cursor: pointer;
      font-size: 14px;
      line-height: 1;

      &:hover {
        color: #3d64f3;
      }
    }

    .select-item-active {
      border-radius: 12px;
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(44, 70, 137, 0.12);
      color: #3d64f3;
    }
  }

  .mb-0 {
    margin-bottom: 0;
  }
}
</style>
